import styled from 'styled-components/native'

export const Avatar = styled.Image`
  min-width: 32px;
  min-height: 32px;
  height: 32px;
  width: 32px;
  border-radius: 18px;
`
